import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Connects to data-controller="store-filters"
export default class extends Controller {
  static targets = [
    "filterCol", "form", "searchInput",
    "filterButton", "closeButton",
    "allKinds", "friendlyKinds"
  ]

  connect() {
    if (this.hasFormTarget) {
      this.formTarget.addEventListener("ajax:success", () => {
        if (this.hasSearchInputTarget) {
          this.searchInputTarget.value = ""
        }
      })
    }

    this.syncCheckboxesByValue()

    // Restaurar estado de dropdowns después de Turbo Stream
    this.restoreDropdownState()
  }

  openFilters() {
    this.filterColTarget.classList.add("show")
  }

  closeFilters() {
    this.filterColTarget.classList.remove("show")
  }

  hideFiltersOnSubmit() {
    // Guardar estado de dropdowns antes de submit
    this.saveDropdownState()
    this.filterColTarget.classList.remove("show")
  }

  // Guardar qué dropdowns están abiertos
  saveDropdownState() {
    const openDropdowns = []
    const collapses = this.element.querySelectorAll('.filter_type .collapse')

    collapses.forEach(collapse => {
      if (collapse.classList.contains('show')) {
        openDropdowns.push(collapse.id)
      }
    })

    sessionStorage.setItem('openFilterDropdowns', JSON.stringify(openDropdowns))
  }

  // Restaurar dropdowns que estaban abiertos
  restoreDropdownState() {
    const saved = sessionStorage.getItem('openFilterDropdowns')
    if (!saved) return

    try {
      const openDropdowns = JSON.parse(saved)

      openDropdowns.forEach(id => {
        const collapse = document.getElementById(id)
        if (collapse) {
          // Usar Bootstrap Collapse API
          const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapse, { toggle: false })
          bsCollapse.show()

          // Actualizar el link toggle
          const toggle = this.element.querySelector(`[data-bs-target="#${id}"]`)
          if (toggle) {
            toggle.classList.remove('closed')
            toggle.classList.add('opened')
          }
        }
      })

      // Limpiar después de restaurar
      sessionStorage.removeItem('openFilterDropdowns')
    } catch (e) {
      console.error('Error restoring dropdown state:', e)
    }
  }

  syncCheckboxesByValue() {
    this.allKindsTargets.forEach(allKind => {
      allKind.addEventListener("change", () => {
        this.friendlyKindsTargets.forEach(friendly => {
          if (friendly.value === allKind.value) {
            friendly.checked = allKind.checked
          }
        })
      })
    })

    this.friendlyKindsTargets.forEach(friendly => {
      friendly.addEventListener("change", () => {
        this.allKindsTargets.forEach(allKind => {
          if (allKind.value === friendly.value) {
            allKind.checked = friendly.checked
          }
        })
      })
    })
  }

  // Métodos para filtros rápidos nativos iOS
  handleQuickFilter(event) {
    const pill = event.currentTarget
    const filterType = pill.dataset.filter

    // Agregar efecto de feedback táctil
    this.addTactileFeedback(pill)

    // Remover clase active de todos los pills
    this.element.querySelectorAll('.quick-filter-pill').forEach(p => {
      p.classList.remove('active')
    })

    // Activar el pill seleccionado
    pill.classList.add('active')

    // Mostrar indicador de carga
    this.showLoadingState()

    // Limpiar filtros actuales
    this.clearAllFilters()

    // Aplicar filtro específico
    switch(filterType) {
      case 'delivery':
        this.applyDeliveryFilter()
        break
      case 'discount':
        this.applyDiscountFilter()
        break
      case 'nearby':
        this.applyNearbyFilter()
        break
      case 'all':
      default:
        // No aplicar filtros adicionales
        break
    }

    // Enviar formulario automáticamente
    this.submitForm()
  }

  addTactileFeedback(element) {
    // Agregar clase de feedback táctil
    element.classList.add('pressed')

    // Simular vibración en dispositivos compatibles
    if (navigator.vibrate) {
      navigator.vibrate(50)
    }

    // Remover clase después de la animación
    setTimeout(() => {
      element.classList.remove('pressed')
    }, 150)
  }

  showLoadingState() {
    const searchWrapper = this.element.querySelector('.native-search-wrapper')
    if (searchWrapper) {
      searchWrapper.classList.add('loading')

      // Remover loading state después de enviar el formulario
      setTimeout(() => {
        searchWrapper.classList.remove('loading')
      }, 1500)
    }
  }

  clearAllFilters() {
    // Limpiar checkboxes de tipos de local
    this.allKindsTargets.forEach(checkbox => {
      checkbox.checked = false
    })

    // Limpiar checkboxes de categorías
    this.element.querySelectorAll('.all-categories').forEach(checkbox => {
      checkbox.checked = false
    })

    // Limpiar otros filtros
    const deliveryCheckbox = this.element.querySelector('[name="q[owner_delivery_eq]"]')
    if (deliveryCheckbox) deliveryCheckbox.checked = false

    const discountCheckbox = this.element.querySelector('[name="q[products_discounts_active_eq]"]')
    if (discountCheckbox) discountCheckbox.checked = false
  }

  applyDeliveryFilter() {
    const deliveryCheckbox = this.element.querySelector('[name="q[owner_delivery_eq]"]')
    if (deliveryCheckbox) {
      deliveryCheckbox.checked = true
    }
  }

  applyDiscountFilter() {
    const discountCheckbox = this.element.querySelector('[name="q[products_discounts_active_eq]"]')
    if (discountCheckbox) {
      discountCheckbox.checked = true
    }
  }

  applyNearbyFilter() {
    // Aquí podrías implementar lógica de geolocalización
    // Por ahora, simplemente no aplica filtros adicionales
    console.log('Filtro de cercanía aplicado')
  }

  submitForm() {
    if (this.hasFormTarget) {
      // Guardar estado antes de submit
      this.saveDropdownState()

      // Pequeño delay para mejorar UX
      setTimeout(() => {
        this.formTarget.submit()
      }, 200)
    }
  }
}
